module.exports = __webpack_public_path__ + "common/icon-download-white-1efa230a0e0ca6ec3393f23dc7122831.svg";